import store from 'Store/index';

export default function allowed() {
	const state = store.getState();
	return !!(state.App.phoneIntegration ?? false);
}
